import React from 'react';
import en from 'react-intl/locale-data/en';
import { addLocaleData, IntlProvider } from 'react-intl';
import { Provider as MobxProvider } from 'mobx-react';
import AntLocaleProvider from 'antd/lib/locale-provider';
import { APP_THEMES, ThemeContext } from 'app-themes';
import { once } from 'lodash-es';

import AppLayout from 'AppClient/routes/AppLayout';
import { RootStore } from 'AppClient/stores';
import { withAuthComponent } from 'components/PrivateRoute/PrivateRoute';
import { User } from 'oidc-client';

addLocaleData([...en]);
const locale = 'en';
const stores = once(user => new RootStore(user));
const RestrictedApp: React.FC<{ user: User }> = ({ user }) => {
	//const theme = user.gs_provider_id === 1 ? APP_THEMES.GSK : '';
	const theme = APP_THEMES.GSK;

	return (
		<MobxProvider {...stores(user)}>
			<AntLocaleProvider key={locale}>
				<IntlProvider key={locale} locale={locale}>
					<ThemeContext.Provider value={theme}>
						<AppLayout />
					</ThemeContext.Provider>
				</IntlProvider>
			</AntLocaleProvider>
		</MobxProvider>
	);
};

export default withAuthComponent(RestrictedApp);
